<template>
  <div class="filter-split-container">
    <div
      class="filter-split-container-child left-container"
      v-show="showLeftContainer"
      v-bind:style="{
        width: showRightContainer
          ? `calc(100% - ${rightContainerWidth}px)`
          : '100%',
      }"
    >
      <slot name="leftContent"></slot>
    </div>
    <div
      class="filter-split-container-child right-container"
      v-show="showRightContainer"
      v-bind:style="{ width: `${rightContainerWidth}px` }"
    >
      <slot name="rightContent"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showLeftContainer: {
      type: Boolean,
      default: true,
    },
    showRightContainer: {
      type: Boolean,
      default: false,
    },
    rightContainerWidth: {
      type: [Number, String],
      default: 410,
    },
  },
};
</script>

<style lang="scss">
.filter-split-container {
  width: 100%;
  // .left-container {
  //   width: calc(100% - 350px);
  // }
  .right-container {
    // width: 410px !important;
    .view-card.responsive-paddings {
      padding: 10px 20px 10px 20px !important;
    }
  }

  .dx-tag-content span {
    font-size: 10px;
  }

  .filter-split-container-child.right-container {
    border-left: 1px solid rgba(0, 0, 0, 0.12);
    margin-top: 0;
    margin-right: 0;
    .split-view-toolbar {
      border-bottom: 1px solid rgba(0, 0, 0, 0.12);
      -webkit-box-shadow: none;
      box-shadow: none;
    }
    .view-card {
      -webkit-box-shadow: none;
      box-shadow: none;
    }
  }
}

.split-container,
.filter-split-container {
  display: flex;
  flex-wrap: nowrap;
}

.split-container-child {
  flex-grow: 1;
  margin: 5px;
  margin-bottom: 0;
  margin-top: 0;
}

.split-view-toolbar {
  -webkit-box-shadow: 0 0px 3px rgba(0, 0, 0, 0.12),
    0 0px 1px rgba(0, 0, 0, 0.24);
  box-shadow: 0 0px 3px rgba(0, 0, 0, 0.12), 0 0px 1px rgba(0, 0, 0, 0.24);
  background-color: #fff;
  padding-left: 10px;
  padding-right: 10px;
}

.split-view-card {
  -webkit-box-shadow: 0 0px 3px rgba(0, 0, 0, 0.12),
    0 0px 1px rgba(0, 0, 0, 0.24);
  box-shadow: 0 0px 3px rgba(0, 0, 0, 0.12), 0 0px 1px rgba(0, 0, 0, 0.24);
  background-color: #fff;
  margin: 2px 0px 3px;
}
</style>
